import { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Dialog } from '../../../components/Dialog';
import { getFarmqaLayers } from '../../../services/admin-service';
import { useAlerts } from '../../../hooks/use-alerts';
import { Table } from '../../../components/table/Table';
import { TableStatus } from '../../../components/table/TableStatus';

export function Field(props) {
  const { field, onClose } = props;
  const [layers, setLayers] = useState();
  const { showError } = useAlerts();

  const loadLayers = useCallback(
    () => getFarmqaLayers(field.aaid).then(setLayers).catch(showError),
    [field.aaid, showError],
  );

  useEffect(() => {
    loadLayers();
  }, [loadLayers]);

  return (
    <Dialog title={field.name} width="md" actions={false} onCancel={onClose}>
      <Box sx={{ height: 'calc(100vh - 450px)' }}>{buildLayers()}</Box>
    </Dialog>
  );

  function buildLayers() {
    return (
      <Table
        loading={!layers}
        columns={buildColumns()}
        rows={layers || []}
        hideFooter={false}
        initialState={{
          sorting: {
            sortModel: [
              { field: 'year', sort: 'desc' },
              { field: 'status', sort: 'asc' },
              { field: 'layer', sort: 'asc' },
            ],
          },
        }}
      />
    );
  }

  function buildColumns() {
    return [
      {
        field: 'layer',
        headerName: 'Layer',
        flex: 1,
      },
      {
        field: 'year',
        headerName: 'Year',
        flex: 1,
      },
      {
        field: 'imageDate',
        headerName: 'Image Date',
        type: 'dateTime',
        flex: 1,
        valueFormatter: ({ value }) =>
          value ? new Date(value).toLocaleString() : '--',
      },
      {
        field: 'status',
        headerName: 'Status',
        flex: 0.75,
        renderCell: ({ row }) => <TableStatus status={row.syncStatus} />,
      },
      {
        field: 'syncedAt',
        headerName: 'Synced At',
        flex: 1,
        type: 'dateTime',
        valueFormatter: ({ value }) =>
          value ? new Date(value).toLocaleString() : '--',
      },
    ];
  }
}
